// third-party
import { configureStore } from "@reduxjs/toolkit";
import {
  commentApi,
  cropApi,
  coordinatesApi,
  pestApi,
  userApi,
  weedApi,
  cropsPestApi,
  diseasesApi,
  helperApi,
  imageManagerApi,
  pdfApi,
  searchApi,
  observedCropApi,
  degreeDaysApi,
} from "../api";

import menu from "./reducers/menu";
import auth from "./reducers/auth";
import user from "./reducers/user";
import descriptionModal from "./reducers/descriptionModal";
import cropModal from "./reducers/cropModal";
import pestModal from "./reducers/pestModal";
import usersModal from "./reducers/usersModal";
import diseaseModal from "./reducers/diseaseModal";
import weedModal from "./reducers/weedModal";
import imageManagerModal from "./reducers/imageManagerModal";
import pdfModal from "./reducers/pdfModal";
import observedCropModal from './reducers/observedCropModal'
import pestThresholdModal from './reducers/pestThresholdModal'
import entitySelector from './reducers/entitySelector'
import thresholdForm from './reducers/thresholdForm'

// project import

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const store = configureStore({
  reducer: {
    [cropApi.reducerPath]: cropApi.reducer,
    [commentApi.reducerPath]: commentApi.reducer,
    [coordinatesApi.reducerPath]: coordinatesApi.reducer,
    [pestApi.reducerPath]: pestApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [weedApi.reducerPath]: weedApi.reducer,
    [cropsPestApi.reducerPath]: cropsPestApi.reducer,
    [diseasesApi.reducerPath]: diseasesApi.reducer,
    [helperApi.reducerPath]: helperApi.reducer,
    [imageManagerApi.reducerPath]: imageManagerApi.reducer,
    [pdfApi.reducerPath]: pdfApi.reducer,
    [searchApi.reducerPath]: searchApi.reducer,
    [observedCropApi.reducerPath]: observedCropApi.reducer,
    [degreeDaysApi.reducerPath]: degreeDaysApi.reducer,
    menu,
    menu,
    auth,
    user,
    descriptionModal,
    cropModal,
    pestModal,
    usersModal,
    diseaseModal,
    weedModal,
    imageManagerModal,
    pdfModal,
    observedCropModal,
    pestThresholdModal,
    entitySelector,
    thresholdForm
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(cropApi.middleware)
      .concat(commentApi.middleware)
      .concat(coordinatesApi.middleware)
      .concat(pestApi.middleware)
      .concat(userApi.middleware)
      .concat(weedApi.middleware)
      .concat(cropsPestApi.middleware)
      .concat(diseasesApi.middleware)
      .concat(helperApi.middleware)
      .concat(imageManagerApi.middleware)
      .concat(pdfApi.middleware)
      .concat(searchApi.middleware)
      .concat(observedCropApi.middleware)
      .concat(degreeDaysApi.middleware),  
});

const { dispatch } = store;

export { store, dispatch };
